module.exports = __webpack_public_path__ + "static/image005-18799eb15b463e6d7747cc336ebe4533.jpg";